import { render, staticRenderFns } from "./routeCustomerList.vue?vue&type=template&id=a1e5b2f2"
import script from "./routeCustomerList.vue?vue&type=script&lang=js"
export * from "./routeCustomerList.vue?vue&type=script&lang=js"
import style0 from "./routeCustomerList.vue?vue&type=style&index=0&id=a1e5b2f2&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports